<template>
  <v-container fluid>
    <v-data-table
      :search="search"
      :headers="headers"
      :items="productos"
      :items-per-page="20"
      :footer-props="{
        itemsPerPageText: 'El. por página',
        itemsPerPageAllText: 'Todo',
        itemsPerPageOptions: ippoptions,
      }"
      no-results-text="No hay resultados"
      no-data-text="No hay datos para mostrar"
    >
      <template v-slot:top>
        <v-container fluid class="pa-0">
          <v-row>
            <v-col cols="12" md="10" class="py-0">
              <v-text-field v-model="search" label="Buscar"></v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="py-0">
              <v-btn
                color="primary"
                class="mt-lg-3"
                @click="openAddDialog"
                block
              >
                <v-icon>mdi-plus</v-icon>Agregar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </template>
      <template v-slot:item.attributes.codigo="{ item }">
        <div>{{ item.attributes.codigo | uppercase }}</div>
      </template>
      <template v-slot:item.attributes.precio_lista="{ item }">
        <div>{{ item.attributes.precio_lista | currency }}</div>
      </template>
      <template v-slot:item.attributes.familia="{ item }">
        <div>{{ item.attributes.familia | uppercase }}</div>
      </template>
      <template v-slot:item.acciones="{ item }">
        <v-btn class="ma-1" color="accent" fab small @click="openDialog(item)"
          ><v-icon>mdi-pencil</v-icon></v-btn
        >
        <v-btn
          class="ma-1"
          color="warning"
          fab
          small
          @click="requestDeleteProduct(item)"
          ><v-icon>mdi-delete</v-icon></v-btn
        >
      </template>
    </v-data-table>
    <PanelTerniumDialog
      :trigger="dialog"
      :product="selectedProduct"
      @onAddRequest="addProduct"
      @onEditRequest="editProduct"
      @onCancel="resetDialog"
    />
    <ConfirmationDialog
      :dialog_ref="deleteDialog"
      :dialogTitle="'Eliminar producto'"
      :dialogMsg="'¿Está seguro que desea elimnar este producto? Esta acción no se puede deshacer.'"
      :confirmBtnText="'Eliminar'"
      :confirmBtnIcon="'mdi-delete'"
      :confirmBtnStyle="'warning'"
      @onConfirm="deleteProduct"
      @onCancel="resetDialog"
    />
  </v-container>
</template>

<script>
import { httpGet, httpPost, httpPut, httpDelete } from "@/services/apiService";
import PanelTerniumDialog from "./PanelTerniumDialog.vue";
import ConfirmationDialog from "@/components/ConfirmationDialog";
export default {
  components: { PanelTerniumDialog, ConfirmationDialog },
  data() {
    return {
      overlay: false,
      search: "",
      headers: [
        {
          text: "Código",
          align: "center",
          sortable: true,
          value: "attributes.codigo",
        },
        {
          text: "Descripción",
          align: "center",
          sortable: true,
          value: "attributes.descripcion",
        },
        {
          text: "Familia",
          align: "center",
          sortable: true,
          value: "attributes.familia",
        },
        {
          text: "Precio de lista",
          align: "center",
          sortable: true,
          value: "attributes.precio_lista",
        },
        {
          text: "Acciones",
          align: "center",
          sortable: false,
          value: "acciones",
        },
      ],
      productos: [],
      ippoptions: [10, 20, 30, 40, 50, -1],
      sheets: [],
      dialog: false,
      selectedProduct: null,
      deleteDialog: false,
      selectedForDeletion: null,
    };
  },
  methods: {
    openAddDialog() {
      this.dialog = true;
    },
    openDialog(item) {
      this.selectedProduct = item;
      this.dialog = true;
    },
    async getData() {
      this.overlay = true;
      const { data } = await httpGet("/productos?filters[familia][$eq]=panel_ternium&populate=grosores").catch((error) => {
        this.$toasted.show(
          "Ha ocurrido un error al obtener la información. Intente de nuevo más tarde.",
          { type: "error" }
        );
        this.resetDialog();
        this.overlay = false;
        return;
      });
      (data?.data);
      this.productos = data?.data;
      this.overlay = false;
    },
    async addProduct(data) {
      const { data: postData } = await httpPost("/productos", { data }).catch(
        (error) => {
          this.$toasted.show(
            "Ha ocurrido un error al agregar el producto. Intente de nuevo más tarde.",
            { type: "error" }
          );
          this.resetDialog();
          this.overlay = false;
          return;
        }
      );
      (postData?.data);
      this.$toasted.show("Producto agregado. Actualizando el catálogo...", {
        type: "success",
      });
      this.getData();
      this.resetDialog();
    },
    async editProduct(data) {
      const { data: putData } = await httpPut("/productos/" + data.id, {
        data,
      }).catch((error) => {
        this.$toasted.show(
          "Ha ocurrido un error al editar el producto. Intente de nuevo más tarde.",
          { type: "error" }
        );
        this.resetDialog();
        this.overlay = false;
        return;
      });

      (putData?.data);
      this.$toasted.show("Producto editado. Actualizando el catálogo...", {
        type: "success",
      });
      this.getData();
      this.resetDialog();
    },
    async deleteProduct() {
      const { data } = await httpDelete(
        "/productos/" + this.selectedForDeletion.id
      ).catch((error) => {
        this.$toasted.show(
          "Ha ocurrido un error al eliminar el producto. Intente de nuevo más tarde.",
          { type: "error" }
        );
        this.resetDialog();
        this.overlay = false;
        return;
      });
      (data?.data);
      this.$toasted.show("Producto eliminado. Actualizando el catálogo...", {
        type: "success",
      });
      this.getData();
      this.resetDialog();
    },
    requestDeleteProduct(event) {
      this.selectedForDeletion = event;
      this.deleteDialog = true;
    },
    resetDialog() {
      this.dialog = false;
      this.deleteDialog = false;
      this.selectedProduct = null;
      this.selectedForDeletion = null;
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style>
</style>